var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as _ from "lodash";
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import * as SampleFactory from "../../classes/definitions/sample/sample";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import SamplesList from '../../components/Samples/SamplesList/SamplesList';
import AppRoutes from '../../config/appRoutes';
import SamplesReduxProps from "./SamplesReduxProps";
var Samples = /** @class */ (function (_super) {
    __extends(Samples, _super);
    function Samples() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.queryParams = { page: 1, filter: '' };
        _this.state = {
            data: [],
            meta: null
        };
        _this.getAllSamples = function () {
            _this.api.getSamples(_this.queryParams)
                .then(function (response) {
                var samples = SampleFactory.createSamples(response.data);
                var meta = _.get(response, 'data.meta', null);
                _this.setState({ data: samples, meta: meta });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим списъка със сампли', _this.props.history);
            });
        };
        _this.toNewSample = function () {
            _this.props.history.push(AppRoutes.sample.path);
        };
        // Deleting the item from the state
        _this.deleteItem = function (id) {
            var data = __spreadArrays(_this.state.data);
            var result = data.find(function (item) {
                return item.Id === id;
            });
            var index = data.indexOf(result);
            data.splice(index, 1);
            _this.setState({ data: data });
        };
        _this.changePage = function (pageNum) {
            _this.queryParams.page = pageNum;
            _this.getAllSamples();
        };
        return _this;
    }
    Samples.prototype.componentDidMount = function () {
        this.getAllSamples();
    };
    Samples.prototype.render = function () {
        var _this = this;
        var _a = this.state, data = _a.data, meta = _a.meta;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u0421\u0430\u043C\u043F\u043B\u0438"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewSample, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432 \u0441\u0430\u043C\u043F\u043B\u044A\u043B")),
                        React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
                        React.createElement(SamplesList, { gridData: data, meta: meta, messages: this.messages, deleteItem: this.deleteItem, changePage: this.changePage }))))));
    };
    return Samples;
}(React.Component));
export default connect(null, SamplesReduxProps.mapDispatchToProps)(Samples);



//////////////////
// WEBPACK FOOTER
// ./src/views/Samples/Samples.tsx
// module id = 450
// module chunks = 0